import { render, staticRenderFns } from "./conferimadddataviews.vue?vue&type=template&id=9aed349e"
import script from "./conferimadddataviews.vue?vue&type=script&lang=js"
export * from "./conferimadddataviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports